package com.milta.feature.admin.presentation

sealed interface AdminUsersIntent {
    data object Load : AdminUsersIntent

    data class UpdateSearch(val query: String) : AdminUsersIntent

    data class ToggleOrganisation(val enterpriseId: String) : AdminUsersIntent

    data object ExpandAll : AdminUsersIntent

    data object CollapseAll : AdminUsersIntent
}
